"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoderEncoderAvailablity = exports.Connectivity = exports.ConfigTargetingRequest = exports.Connectivity_NetworkType = exports.ConfigTargetingInstrumentation = exports.ConfigTargetingAppState = exports.ConfigTargetingTriggerEventType = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const benchmark_1 = require("./benchmark");
const ruid_1 = require("../../common/ruid");
const wrappers_1 = require("../../google/protobuf/wrappers");
exports.protobufPackage = "snapchat.cdp.cof";
/** Indicates what was the state of the app when the config sync was triggered */
var ConfigTargetingTriggerEventType;
(function (ConfigTargetingTriggerEventType) {
    /** UNKNOWN_EVENT_TYPE - Unknown */
    ConfigTargetingTriggerEventType[ConfigTargetingTriggerEventType["UNKNOWN_EVENT_TYPE"] = 0] = "UNKNOWN_EVENT_TYPE";
    /** COLD_START - Deprecated because of simplification to FG/BG */
    ConfigTargetingTriggerEventType[ConfigTargetingTriggerEventType["COLD_START"] = 1] = "COLD_START";
    /** WARM_START - Deprecated because of simplification to FG/BG */
    ConfigTargetingTriggerEventType[ConfigTargetingTriggerEventType["WARM_START"] = 2] = "WARM_START";
    /** FOREGROUND_TRIGGER - Triggered when application is in the foreground */
    ConfigTargetingTriggerEventType[ConfigTargetingTriggerEventType["FOREGROUND_TRIGGER"] = 3] = "FOREGROUND_TRIGGER";
    /** BACKGROUND_TRIGGER - Triggered when application is backgrounded */
    ConfigTargetingTriggerEventType[ConfigTargetingTriggerEventType["BACKGROUND_TRIGGER"] = 4] = "BACKGROUND_TRIGGER";
    ConfigTargetingTriggerEventType[ConfigTargetingTriggerEventType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ConfigTargetingTriggerEventType = exports.ConfigTargetingTriggerEventType || (exports.ConfigTargetingTriggerEventType = {}));
/**
 * Indicates what was the state of the app when the config sync happens
 * The enum is also used as a dynamic client property to populate feature signals
 */
var ConfigTargetingAppState;
(function (ConfigTargetingAppState) {
    /** UNKNOWN_APP_STATE - Unknown */
    ConfigTargetingAppState[ConfigTargetingAppState["UNKNOWN_APP_STATE"] = 0] = "UNKNOWN_APP_STATE";
    /** FOREGROUND - Foreground */
    ConfigTargetingAppState[ConfigTargetingAppState["FOREGROUND"] = 1] = "FOREGROUND";
    /** BACKGROUND - Background */
    ConfigTargetingAppState[ConfigTargetingAppState["BACKGROUND"] = 2] = "BACKGROUND";
    ConfigTargetingAppState[ConfigTargetingAppState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ConfigTargetingAppState = exports.ConfigTargetingAppState || (exports.ConfigTargetingAppState = {}));
/**
 * We expect this enum to be updated whenever there is a new sync instrumentation: This will help us isolate new changes on
 * server side to avoid post mortems like https://snapchat.quip.com/xGnVAcsBrOeC
 */
var ConfigTargetingInstrumentation;
(function (ConfigTargetingInstrumentation) {
    /** DEFAULT_INSTRUMENTATION - Default */
    ConfigTargetingInstrumentation[ConfigTargetingInstrumentation["DEFAULT_INSTRUMENTATION"] = 0] = "DEFAULT_INSTRUMENTATION";
    /** USER_AUTHENTICATION - User logged in */
    ConfigTargetingInstrumentation[ConfigTargetingInstrumentation["USER_AUTHENTICATION"] = 1] = "USER_AUTHENTICATION";
    ConfigTargetingInstrumentation[ConfigTargetingInstrumentation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ConfigTargetingInstrumentation = exports.ConfigTargetingInstrumentation || (exports.ConfigTargetingInstrumentation = {}));
/** NetworkType */
var Connectivity_NetworkType;
(function (Connectivity_NetworkType) {
    /** UNKNOWN_NETWORK_TYPE - Unknown */
    Connectivity_NetworkType[Connectivity_NetworkType["UNKNOWN_NETWORK_TYPE"] = 0] = "UNKNOWN_NETWORK_TYPE";
    /** CELLULAR - Cellular */
    Connectivity_NetworkType[Connectivity_NetworkType["CELLULAR"] = 1] = "CELLULAR";
    /** WIFI - Wifi */
    Connectivity_NetworkType[Connectivity_NetworkType["WIFI"] = 2] = "WIFI";
    Connectivity_NetworkType[Connectivity_NetworkType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Connectivity_NetworkType = exports.Connectivity_NetworkType || (exports.Connectivity_NetworkType = {}));
const baseConfigTargetingRequest = {
    configResultsEtag: "",
    namespaces: 0,
    ghostId: "",
    countryCode: "",
    screenWidth: 0,
    screenHeight: 0,
    maxVideoWidthPx: 0,
    maxVideoHeightPx: 0,
    deltaSync: false,
    userAgent: "",
    triggerEventType: 0,
    appState: 0,
    locale: "",
    deviceId: "",
    userId: "",
    clientIp: "",
    isUnAuthorized: false,
    appLocale: "",
    instrumentation: 0,
    lastSuccessfulSync: 0,
    isLogout: false,
    packageInstaller: "",
    syncTriggerBlizzardSessionId: "",
    syncExecutionBlizzardSessionId: "",
    cofSyncTriggerDelayFromStartupMs: 0,
    cofSyncExecutionDelayFromStartupMs: 0,
    syncTriggerTime: 0,
    snapkitAppId: "",
    lenscoreVersion: 0,
    configNames: "",
    includeTestUserTreatments: false,
    disableExposureLogging: false,
    lensClusterOrig4: 0,
    clientId: "",
};
exports.ConfigTargetingRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.configResultsEtag !== "") {
            writer.uint32(10).string(message.configResultsEtag);
        }
        writer.uint32(18).fork();
        for (const v of message.namespaces) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.ghostId !== "") {
            writer.uint32(26).string(message.ghostId);
        }
        if (message.countryCode !== "") {
            writer.uint32(34).string(message.countryCode);
        }
        if (message.screenWidth !== 0) {
            writer.uint32(40).int32(message.screenWidth);
        }
        if (message.screenHeight !== 0) {
            writer.uint32(48).int32(message.screenHeight);
        }
        if (message.connectivity !== undefined) {
            exports.Connectivity.encode(message.connectivity, writer.uint32(58).fork()).ldelim();
        }
        if (message.maxVideoWidthPx !== 0) {
            writer.uint32(64).int32(message.maxVideoWidthPx);
        }
        if (message.maxVideoHeightPx !== 0) {
            writer.uint32(72).int32(message.maxVideoHeightPx);
        }
        for (const v of message.benchmarkResults) {
            benchmark_1.BenchmarkResult.encode(v, writer.uint32(82).fork()).ldelim();
        }
        if (message.deltaSync === true) {
            writer.uint32(88).bool(message.deltaSync);
        }
        if (message.userAgent !== "") {
            writer.uint32(98).string(message.userAgent);
        }
        if (message.triggerEventType !== 0) {
            writer.uint32(104).int32(message.triggerEventType);
        }
        if (message.appState !== 0) {
            writer.uint32(112).int32(message.appState);
        }
        if (message.locale !== "") {
            writer.uint32(122).string(message.locale);
        }
        if (message.deviceId !== "") {
            writer.uint32(130).string(message.deviceId);
        }
        if (message.userId !== "") {
            writer.uint32(138).string(message.userId);
        }
        if (message.clientIp !== "") {
            writer.uint32(146).string(message.clientIp);
        }
        if (message.isUnAuthorized === true) {
            writer.uint32(152).bool(message.isUnAuthorized);
        }
        if (message.appLocale !== "") {
            writer.uint32(162).string(message.appLocale);
        }
        if (message.instrumentation !== 0) {
            writer.uint32(168).int32(message.instrumentation);
        }
        if (message.lastSuccessfulSync !== 0) {
            writer.uint32(176).int64(message.lastSuccessfulSync);
        }
        if (message.isLogout === true) {
            writer.uint32(184).bool(message.isLogout);
        }
        if (message.packageInstaller !== "") {
            writer.uint32(194).string(message.packageInstaller);
        }
        if (message.syncTriggerBlizzardSessionId !== "") {
            writer.uint32(202).string(message.syncTriggerBlizzardSessionId);
        }
        if (message.syncExecutionBlizzardSessionId !== "") {
            writer.uint32(210).string(message.syncExecutionBlizzardSessionId);
        }
        if (message.cofSyncTriggerDelayFromStartupMs !== 0) {
            writer.uint32(216).int32(message.cofSyncTriggerDelayFromStartupMs);
        }
        if (message.cofSyncExecutionDelayFromStartupMs !== 0) {
            writer.uint32(224).int32(message.cofSyncExecutionDelayFromStartupMs);
        }
        if (message.syncTriggerTime !== 0) {
            writer.uint32(232).int64(message.syncTriggerTime);
        }
        if (message.decoderEncoderAvailability !== undefined) {
            exports.DecoderEncoderAvailablity.encode(message.decoderEncoderAvailability, writer.uint32(242).fork()).ldelim();
        }
        if (message.snapkitAppId !== "") {
            writer.uint32(250).string(message.snapkitAppId);
        }
        if (message.lenscoreVersion !== 0) {
            writer.uint32(256).int32(message.lenscoreVersion);
        }
        if (message.ruid !== undefined) {
            ruid_1.Ruid.encode(message.ruid, writer.uint32(266).fork()).ldelim();
        }
        for (const v of message.configNames) {
            writer.uint32(274).string(v);
        }
        if (message.includeTestUserTreatments === true) {
            writer.uint32(288).bool(message.includeTestUserTreatments);
        }
        if (message.disableExposureLogging === true) {
            writer.uint32(296).bool(message.disableExposureLogging);
        }
        if (message.lensClusterOrig4 !== 0) {
            writer.uint32(304).int32(message.lensClusterOrig4);
        }
        if (message.clientId !== "") {
            writer.uint32(314).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseConfigTargetingRequest);
        message.namespaces = [];
        message.benchmarkResults = [];
        message.configNames = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.configResultsEtag = reader.string();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.namespaces.push(reader.int32());
                        }
                    }
                    else {
                        message.namespaces.push(reader.int32());
                    }
                    break;
                case 3:
                    message.ghostId = reader.string();
                    break;
                case 4:
                    message.countryCode = reader.string();
                    break;
                case 5:
                    message.screenWidth = reader.int32();
                    break;
                case 6:
                    message.screenHeight = reader.int32();
                    break;
                case 7:
                    message.connectivity = exports.Connectivity.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.maxVideoWidthPx = reader.int32();
                    break;
                case 9:
                    message.maxVideoHeightPx = reader.int32();
                    break;
                case 10:
                    message.benchmarkResults.push(benchmark_1.BenchmarkResult.decode(reader, reader.uint32()));
                    break;
                case 11:
                    message.deltaSync = reader.bool();
                    break;
                case 12:
                    message.userAgent = reader.string();
                    break;
                case 13:
                    message.triggerEventType = reader.int32();
                    break;
                case 14:
                    message.appState = reader.int32();
                    break;
                case 15:
                    message.locale = reader.string();
                    break;
                case 16:
                    message.deviceId = reader.string();
                    break;
                case 17:
                    message.userId = reader.string();
                    break;
                case 18:
                    message.clientIp = reader.string();
                    break;
                case 19:
                    message.isUnAuthorized = reader.bool();
                    break;
                case 20:
                    message.appLocale = reader.string();
                    break;
                case 21:
                    message.instrumentation = reader.int32();
                    break;
                case 22:
                    message.lastSuccessfulSync = longToNumber(reader.int64());
                    break;
                case 23:
                    message.isLogout = reader.bool();
                    break;
                case 24:
                    message.packageInstaller = reader.string();
                    break;
                case 25:
                    message.syncTriggerBlizzardSessionId = reader.string();
                    break;
                case 26:
                    message.syncExecutionBlizzardSessionId = reader.string();
                    break;
                case 27:
                    message.cofSyncTriggerDelayFromStartupMs = reader.int32();
                    break;
                case 28:
                    message.cofSyncExecutionDelayFromStartupMs = reader.int32();
                    break;
                case 29:
                    message.syncTriggerTime = longToNumber(reader.int64());
                    break;
                case 30:
                    message.decoderEncoderAvailability = exports.DecoderEncoderAvailablity.decode(reader, reader.uint32());
                    break;
                case 31:
                    message.snapkitAppId = reader.string();
                    break;
                case 32:
                    message.lenscoreVersion = reader.int32();
                    break;
                case 33:
                    message.ruid = ruid_1.Ruid.decode(reader, reader.uint32());
                    break;
                case 34:
                    message.configNames.push(reader.string());
                    break;
                case 36:
                    message.includeTestUserTreatments = reader.bool();
                    break;
                case 37:
                    message.disableExposureLogging = reader.bool();
                    break;
                case 38:
                    message.lensClusterOrig4 = reader.int32();
                    break;
                case 39:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseConfigTargetingRequest);
        message.namespaces = [];
        message.benchmarkResults = [];
        message.configNames = [];
        if (object.configResultsEtag !== undefined &&
            object.configResultsEtag !== null) {
            message.configResultsEtag = object.configResultsEtag;
        }
        else {
            message.configResultsEtag = "";
        }
        if (object.namespaces !== undefined && object.namespaces !== null) {
            for (const e of object.namespaces) {
                message.namespaces.push(e);
            }
        }
        if (object.ghostId !== undefined && object.ghostId !== null) {
            message.ghostId = object.ghostId;
        }
        else {
            message.ghostId = "";
        }
        if (object.countryCode !== undefined && object.countryCode !== null) {
            message.countryCode = object.countryCode;
        }
        else {
            message.countryCode = "";
        }
        if (object.screenWidth !== undefined && object.screenWidth !== null) {
            message.screenWidth = object.screenWidth;
        }
        else {
            message.screenWidth = 0;
        }
        if (object.screenHeight !== undefined && object.screenHeight !== null) {
            message.screenHeight = object.screenHeight;
        }
        else {
            message.screenHeight = 0;
        }
        if (object.connectivity !== undefined && object.connectivity !== null) {
            message.connectivity = exports.Connectivity.fromPartial(object.connectivity);
        }
        else {
            message.connectivity = undefined;
        }
        if (object.maxVideoWidthPx !== undefined &&
            object.maxVideoWidthPx !== null) {
            message.maxVideoWidthPx = object.maxVideoWidthPx;
        }
        else {
            message.maxVideoWidthPx = 0;
        }
        if (object.maxVideoHeightPx !== undefined &&
            object.maxVideoHeightPx !== null) {
            message.maxVideoHeightPx = object.maxVideoHeightPx;
        }
        else {
            message.maxVideoHeightPx = 0;
        }
        if (object.benchmarkResults !== undefined &&
            object.benchmarkResults !== null) {
            for (const e of object.benchmarkResults) {
                message.benchmarkResults.push(benchmark_1.BenchmarkResult.fromPartial(e));
            }
        }
        if (object.deltaSync !== undefined && object.deltaSync !== null) {
            message.deltaSync = object.deltaSync;
        }
        else {
            message.deltaSync = false;
        }
        if (object.userAgent !== undefined && object.userAgent !== null) {
            message.userAgent = object.userAgent;
        }
        else {
            message.userAgent = "";
        }
        if (object.triggerEventType !== undefined &&
            object.triggerEventType !== null) {
            message.triggerEventType = object.triggerEventType;
        }
        else {
            message.triggerEventType = 0;
        }
        if (object.appState !== undefined && object.appState !== null) {
            message.appState = object.appState;
        }
        else {
            message.appState = 0;
        }
        if (object.locale !== undefined && object.locale !== null) {
            message.locale = object.locale;
        }
        else {
            message.locale = "";
        }
        if (object.deviceId !== undefined && object.deviceId !== null) {
            message.deviceId = object.deviceId;
        }
        else {
            message.deviceId = "";
        }
        if (object.userId !== undefined && object.userId !== null) {
            message.userId = object.userId;
        }
        else {
            message.userId = "";
        }
        if (object.clientIp !== undefined && object.clientIp !== null) {
            message.clientIp = object.clientIp;
        }
        else {
            message.clientIp = "";
        }
        if (object.isUnAuthorized !== undefined && object.isUnAuthorized !== null) {
            message.isUnAuthorized = object.isUnAuthorized;
        }
        else {
            message.isUnAuthorized = false;
        }
        if (object.appLocale !== undefined && object.appLocale !== null) {
            message.appLocale = object.appLocale;
        }
        else {
            message.appLocale = "";
        }
        if (object.instrumentation !== undefined &&
            object.instrumentation !== null) {
            message.instrumentation = object.instrumentation;
        }
        else {
            message.instrumentation = 0;
        }
        if (object.lastSuccessfulSync !== undefined &&
            object.lastSuccessfulSync !== null) {
            message.lastSuccessfulSync = object.lastSuccessfulSync;
        }
        else {
            message.lastSuccessfulSync = 0;
        }
        if (object.isLogout !== undefined && object.isLogout !== null) {
            message.isLogout = object.isLogout;
        }
        else {
            message.isLogout = false;
        }
        if (object.packageInstaller !== undefined &&
            object.packageInstaller !== null) {
            message.packageInstaller = object.packageInstaller;
        }
        else {
            message.packageInstaller = "";
        }
        if (object.syncTriggerBlizzardSessionId !== undefined &&
            object.syncTriggerBlizzardSessionId !== null) {
            message.syncTriggerBlizzardSessionId =
                object.syncTriggerBlizzardSessionId;
        }
        else {
            message.syncTriggerBlizzardSessionId = "";
        }
        if (object.syncExecutionBlizzardSessionId !== undefined &&
            object.syncExecutionBlizzardSessionId !== null) {
            message.syncExecutionBlizzardSessionId =
                object.syncExecutionBlizzardSessionId;
        }
        else {
            message.syncExecutionBlizzardSessionId = "";
        }
        if (object.cofSyncTriggerDelayFromStartupMs !== undefined &&
            object.cofSyncTriggerDelayFromStartupMs !== null) {
            message.cofSyncTriggerDelayFromStartupMs =
                object.cofSyncTriggerDelayFromStartupMs;
        }
        else {
            message.cofSyncTriggerDelayFromStartupMs = 0;
        }
        if (object.cofSyncExecutionDelayFromStartupMs !== undefined &&
            object.cofSyncExecutionDelayFromStartupMs !== null) {
            message.cofSyncExecutionDelayFromStartupMs =
                object.cofSyncExecutionDelayFromStartupMs;
        }
        else {
            message.cofSyncExecutionDelayFromStartupMs = 0;
        }
        if (object.syncTriggerTime !== undefined &&
            object.syncTriggerTime !== null) {
            message.syncTriggerTime = object.syncTriggerTime;
        }
        else {
            message.syncTriggerTime = 0;
        }
        if (object.decoderEncoderAvailability !== undefined &&
            object.decoderEncoderAvailability !== null) {
            message.decoderEncoderAvailability =
                exports.DecoderEncoderAvailablity.fromPartial(object.decoderEncoderAvailability);
        }
        else {
            message.decoderEncoderAvailability = undefined;
        }
        if (object.snapkitAppId !== undefined && object.snapkitAppId !== null) {
            message.snapkitAppId = object.snapkitAppId;
        }
        else {
            message.snapkitAppId = "";
        }
        if (object.lenscoreVersion !== undefined &&
            object.lenscoreVersion !== null) {
            message.lenscoreVersion = object.lenscoreVersion;
        }
        else {
            message.lenscoreVersion = 0;
        }
        if (object.ruid !== undefined && object.ruid !== null) {
            message.ruid = ruid_1.Ruid.fromPartial(object.ruid);
        }
        else {
            message.ruid = undefined;
        }
        if (object.configNames !== undefined && object.configNames !== null) {
            for (const e of object.configNames) {
                message.configNames.push(e);
            }
        }
        if (object.includeTestUserTreatments !== undefined &&
            object.includeTestUserTreatments !== null) {
            message.includeTestUserTreatments = object.includeTestUserTreatments;
        }
        else {
            message.includeTestUserTreatments = false;
        }
        if (object.disableExposureLogging !== undefined &&
            object.disableExposureLogging !== null) {
            message.disableExposureLogging = object.disableExposureLogging;
        }
        else {
            message.disableExposureLogging = false;
        }
        if (object.lensClusterOrig4 !== undefined &&
            object.lensClusterOrig4 !== null) {
            message.lensClusterOrig4 = object.lensClusterOrig4;
        }
        else {
            message.lensClusterOrig4 = 0;
        }
        if (object.clientId !== undefined && object.clientId !== null) {
            message.clientId = object.clientId;
        }
        else {
            message.clientId = "";
        }
        return message;
    },
};
const baseConnectivity = { networkType: 0, carrier: "" };
exports.Connectivity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.networkType !== 0) {
            writer.uint32(8).int32(message.networkType);
        }
        if (message.isMetered !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isMetered }, writer.uint32(18).fork()).ldelim();
        }
        if (message.isRoaming !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isRoaming }, writer.uint32(26).fork()).ldelim();
        }
        if (message.carrier !== "") {
            writer.uint32(34).string(message.carrier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseConnectivity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.networkType = reader.int32();
                    break;
                case 2:
                    message.isMetered = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.isRoaming = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.carrier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseConnectivity);
        if (object.networkType !== undefined && object.networkType !== null) {
            message.networkType = object.networkType;
        }
        else {
            message.networkType = 0;
        }
        if (object.isMetered !== undefined && object.isMetered !== null) {
            message.isMetered = object.isMetered;
        }
        else {
            message.isMetered = undefined;
        }
        if (object.isRoaming !== undefined && object.isRoaming !== null) {
            message.isRoaming = object.isRoaming;
        }
        else {
            message.isRoaming = undefined;
        }
        if (object.carrier !== undefined && object.carrier !== null) {
            message.carrier = object.carrier;
        }
        else {
            message.carrier = "";
        }
        return message;
    },
};
const baseDecoderEncoderAvailablity = {
    isSnapVp9DecoderAvailable: false,
    isSnapAv1DecoderAvailable: false,
};
exports.DecoderEncoderAvailablity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isSnapVp9DecoderAvailable === true) {
            writer.uint32(8).bool(message.isSnapVp9DecoderAvailable);
        }
        if (message.isSnapAv1DecoderAvailable === true) {
            writer.uint32(16).bool(message.isSnapAv1DecoderAvailable);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDecoderEncoderAvailablity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isSnapVp9DecoderAvailable = reader.bool();
                    break;
                case 2:
                    message.isSnapAv1DecoderAvailable = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDecoderEncoderAvailablity);
        if (object.isSnapVp9DecoderAvailable !== undefined &&
            object.isSnapVp9DecoderAvailable !== null) {
            message.isSnapVp9DecoderAvailable = object.isSnapVp9DecoderAvailable;
        }
        else {
            message.isSnapVp9DecoderAvailable = false;
        }
        if (object.isSnapAv1DecoderAvailable !== undefined &&
            object.isSnapAv1DecoderAvailable !== null) {
            message.isSnapAv1DecoderAvailable = object.isSnapAv1DecoderAvailable;
        }
        else {
            message.isSnapAv1DecoderAvailable = false;
        }
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=config_request.js.map